import Vue from "vue";
import AppBreadcrumbs from "./AppBreadcrumbs";

const state = Vue.observable({
  breadcrumbs: []
});

export default {
  install(Vue) {
    // Mixer for components
    Vue.mixin({
      created() {
        if (this.$options.breadcrumb) {
          const breadcrumb = makeBreadcrumb(this);
          state.breadcrumbs.push(breadcrumb);
        }
      },
      beforeDestroy() {
        if (this.$options.breadcrumb) {
          const index = getBreadcrumbIndex(this);
          if (~index) state.breadcrumbs.splice(index, 1);
        }
      }
    });
  }
};

function makeBreadcrumb(component) {
  let { breadcrumb } = component.$options;
  if (typeof breadcrumb === "function") {
    breadcrumb = breadcrumb.bind(component);
  }

  return {
    id: getBreadcrumbId(component),
    breadcrumb
  };
}

function getBreadcrumbIndex(component) {
  return state.breadcrumbs.findIndex(
    item => item.id === getBreadcrumbId(component)
  );
}

function getBreadcrumbId(component) {
  return `breadcrumb_${component._uid}`;
}

export { state, AppBreadcrumbs };
